<div class="d-md-flex align-items-center  p-3">
  <button type="button" class="ml-auto btn btn-rounded btn-success py-2" (click)='saveClick()'><i
      class="fas fa-save  font-14 mr-1 text-white"></i>
    <span class="ml-1 text-white font-weight-bold">Salva</span>
  </button>
</div>
<div class="card">
  <div class="p-3">
    <div class="row">
      <div class="col-lg-3 ">
        <label for="fornitore" required class="control-label col-form-label">Cliente :</label>
        <ng-multiselect-dropdown style="width: 80%; "[settings]="clientidropdownSettings" [placeholder]="'Cliente'" name="fornitore" id="fornitore" [data]="aziende"
                                 [(ngModel)]="aziendeSelezionate"  (ngModelChange)="FornitoreChanged()">
        </ng-multiselect-dropdown>
      </div>
      <div class="col-lg-3 form-group">
        <label class="mb-0 text-dark">Progressivo</label>
        <input type="number" [(ngModel)]="Selected.progressivo" name="data_emissione" class="form-control">
      </div>
      <div class="col-lg-3 form-group">
        <label class="mb-0 text-dark">Numero di fattura</label>
        <input type="text" required #numero = "ngModel"  [(ngModel)]="Selected.numero" name="data_emissione" class="form-control">
        <small class="form-text text-danger" *ngIf="!numero.valid && (numero.dirty || numero.touched)">numero richiesto</small>
      </div>
      <div class="col-lg-3 form-group">
        <label class="mb-0 text-dark">Data di emissione</label>
        <input type="date"  required #data_emissione = "ngModel" [max]="oggi" [(ngModel)]="Selected.data_emissione" name="data_emissione" class="form-control">
        <small class="form-text text-danger" *ngIf="!data_emissione.valid && (data_emissione.dirty || data_emissione.touched)">data di emissione richiesta</small>
      </div>
      <div class="col-lg-3 form-group">
        <label class="mb-0 text-dark">Data prevista</label>
        <input type="date" required #data_prevista = "ngModel"  [(ngModel)]="Selected.data_prevista" name="data_prevista" class="form-control">
        <small class="form-text text-danger" *ngIf="!data_prevista.valid && (data_prevista.dirty || data_prevista.touched)">data di prevista richiesta</small>
      </div>
      <div class="col-lg-3 form-group">
        <label class="mb-0 text-dark">Data di pagamento Previsto</label>
        <input type="date" #data_pagamento_p = "ngModel"  [(ngModel)]="Selected.data_pagamento_p" name="data_pagamento_p" class="form-control">
        <small class="form-text text-danger" *ngIf="!data_pagamento_p.valid && (data_pagamento_p.dirty || data_pagamento_p.touched)">data_pagamento_p richiesta</small>
      </div>
      <div class="col-lg-3 form-group">
        <label class="mb-0 text-dark">Data di pagamento Effettivo</label>
        <input type="date" #data_pagamento_e = "ngModel"  [(ngModel)]="Selected.data_pagamento_e" class="form-control">
        <small class="form-text text-danger" *ngIf="!data_pagamento_e.valid && (data_pagamento_e.dirty || data_pagamento_e.touched)">data_pagamento_e richiesta</small>
      </div>
      <div class="col-lg-3 form-group">
        <label class="mb-0 text-dark">Nominativo</label>
        <input type="text" required #nominativo = "ngModel"  [(ngModel)]="Selected.nominativo" name="nome" class="form-control">
        <small class="form-text text-danger" *ngIf="!nominativo.valid && (nominativo.dirty || nominativo.touched)">Nominativo richiesto</small>
      </div>
      <div class="col-lg-3 form-group">
        <label class="mb-0 text-dark">Indirizzo</label>
        <input type="text" required #indirizzo = "ngModel"  [(ngModel)]="Selected.indirizzo" name="indirizzo" class="form-control">
        <small class="form-text text-danger" *ngIf="!indirizzo.valid && (indirizzo.dirty || indirizzo.touched)">Indirizzo richiesto</small>
      </div>
      <div class="col-lg-3 form-group">
        <label class="mb-0 text-dark">Cap</label>
        <input type="text" required #cap = "ngModel"  [(ngModel)]="Selected.cap" name="cap" class="form-control">
        <small class="form-text text-danger" *ngIf="!cap.valid && (cap.dirty || cap.touched)">cap richiesto</small>
      </div>
      <div class="col-lg-3 form-group">
        <label class="mb-0 text-dark">Città</label>
        <input type="text" required #citta = "ngModel"  [(ngModel)]="Selected.citta" name="citta" class="form-control">
        <small class="form-text text-danger" *ngIf="!citta.valid && (citta.dirty || citta.touched)">citta richiesta</small>
      </div>
      <div class="col-lg-3 form-group">
        <label class="mb-0 text-dark">Provincia</label>
        <input type="text" required #provincia = "ngModel"  [(ngModel)]="Selected.provincia" name="provincia" class="form-control">
        <small class="form-text text-danger" *ngIf="!provincia.valid && (provincia.dirty || provincia.touched)">provincia richiesta</small>
      </div>
      <div class="col-lg-3 form-group">
        <label class="mb-0 text-dark">Nazione</label>
        <input type="text" #nazione = "ngModel"  [(ngModel)]="Selected.nazione" name="nazione" class="form-control">
        <small class="form-text text-danger" *ngIf="!nazione.valid && (nazione.dirty || nazione.touched)">nazione richiesta</small>
      </div>
      <div class="col-lg-3 form-group">
        <label class="mb-0 text-dark">Partita Iva</label>
        <input type="text" #piva = "ngModel"  [(ngModel)]="Selected.piva" name="piva" class="form-control">
        <small class="form-text text-danger" *ngIf="!piva.valid && (piva.dirty || piva.touched)">piva richiesta</small>
      </div>
      <div class="col-lg-3 form-group">
        <label class="mb-0 text-dark">Codice  Fiscale</label>
        <input type="text" #cf = "ngModel"  [(ngModel)]="Selected.cf" name="cf" class="form-control">
        <small class="form-text text-danger" *ngIf="!cf.valid && (cf.dirty || cf.touched)"> codice fiscale richiesto</small>
      </div>
    </div>
  </div>
</div>
<div class="card">
  <div class="card-body">
    <app-voci-di-costo *ngIf="Selected && Selected.voci" [isModifyDisabled]="false" [myProp]="Selected" (resetpage)="refreshinfo()"></app-voci-di-costo>
  </div>
</div>
<div *ngIf="Selected.id" class="card" >
  <app-file-uploader [url]="'/primanota/fatture/file'" [(id)]="Selected.id" (onChange)="refreshinfo()"></app-file-uploader>
</div>
